<template>
  <div :class="$style.container">
    <Grid>
      <GridItem :gridSpan="4">
        <ParagraphBody
          bodySize="large"
        >
          Have questions? Search our knowledge base.
        </ParagraphBody>
      </GridItem>
      <GridItem :gridSpan="5">
        <KnowledgeBaseSearch
          :section="section"
        />
      </GridItem>
    </Grid>
  </div>
</template>

<script>
import {
  Grid,
  GridItem,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import KnowledgeBaseSearch from 'client/components/SearchOurKnowledgeBase/KnowledgeBaseSearch.vue';
import Util from 'client/util/Util';

export default {
  name: 'SearchOurKnowledgeBase',

  EventHelper,
  Util,

  components: {
    Grid,
    GridItem,
    KnowledgeBaseSearch,
    ParagraphBody,
  },

  data() {
    return {
      section: 'KB search bar -- above FAQ',
    };
  },
};
</script>

<style module>
.container {
  border: var(--jc-border);
  padding: var(--jc-spacer-medium);
}
</style>
